import { useEffect } from 'react';

/**
 * O ☰ DA BARRA DO APLICATIVO ABRE A GAVETA DA ÁREA (21/10/2026).
 *
 * No aplicativo a barra de cima é a do `MainLayout` (`AppTopBar`), mas nas áreas do professor, da gestão e da
 * administração a gaveta é da ÁREA (`TeacherLayout`, `GestaoLayout`, `AdminLayout`, com a lista de itens do desktop — ver
 * `temGavetaPropria`). Por isso o professor tinha um botão "Menu" solto abaixo da barra, e o aluno o ☰ na barra: a
 * navegação mudava de lugar conforme o papel. Agora o ☰ da barra manda este evento, a área que está montada abre a
 * gaveta dela, e o botão solto some no aplicativo. A lista de itens continua uma só.
 */
const EVENTO = 'portal:abrir-gaveta-da-area';

export function abrirGavetaDaArea() {
  window.dispatchEvent(new Event(EVENTO));
}

/** Na área que tem gaveta própria: abre a gaveta quando o ☰ da barra do app é tocado. */
export function useAbrirGavetaDaArea(abrir: () => void) {
  useEffect(() => {
    window.addEventListener(EVENTO, abrir);
    return () => window.removeEventListener(EVENTO, abrir);
  }, [abrir]);
}
